// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3reul","filesListContainer":"PosDisputesFiles_filesListContainer__vKnYC","filesButton":"PosDisputesFiles_filesButton__ykmyh"};